// extracted by mini-css-extract-plugin
export var pager = "pager-module--pager--P7yHi";
export var pagerItem = "pager-module--pager-item--2ztit";
export var pagerItemNumber = "pager-module--pager-item-number--1KFlP";